import { createSlice } from "@reduxjs/toolkit";
import { publicProfileApi } from "Services/PublicProfilePageService";
import { countryApi } from "Services/CountryService";
import { getYearList } from "utils/dates";

export const initialState = {
  country: '',
  profileId: '',
  gifts: {
    isLoadingGift: false,
    countyList: [],
    sectorList: [],
    stemmingSearch: false,
    selectedFilters: {
      country: [],
      provinceOrState: [],
      county: [],
      city: [],
      years: [],
      sectors: [],
    },
    provinceOrStateList: [],
    cityList: [],
    yearList: getYearList(),
    giftList: {
      countryList: [],
      pageNumber: 0,
      pageSize: 10,
      pageCount: 0,
      totalCount: 0,
      orderField: 'donationdate',
      orderDirection: 'desc',
      items: [],
    },
  },
  directors: {
    items: [],
    pageNumber: 0,
    pageSize: 10,
    pageCount: 0,
    totalCount: 0,
    orderField: 'directorname',
    orderDirection: 'asc',
  },
  charts: {
    rangeSector: {},
    rangeAmount: {},
    provinceList: [],
  }
};

const publicFoundationProfileSlice = createSlice({
  name: "public-foundation-profile",
  initialState,
  reducers: {
    setProfileId: (state, action) => {
      state.profileId = action.payload;
    },
    setCountry: (state, action) => {
      state.country = action.payload;
    },
    handleChangeFilter: (state, action) => {
      const { key, value } = action.payload;
      state.gifts.selectedFilters[key] = value;
    },
    handleChangeStemmingSearch: (state, action) => {
      state.gifts.stemmingSearch = action.payload;
    },
    handleClearGifts: (state, action) => {
      state.gifts.selectedFilters = initialState.gifts.selectedFilters;

      state.gifts.stemmingSearch = true;

      state.giftList = initialState.gifts.giftList;
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      publicProfileApi.endpoints.getPublicCounties.matchFulfilled, (state, action) => {

        state.gifts.countyList = action.payload.map(county => ({
          id: county.key,
          label: county.label,
          value: county.value,
          secondaryAction: county.provinceOrStateCode,
        }));
      }
    )
      .addMatcher(
        publicProfileApi.endpoints.getPublicGiftsPagedList.matchPending, (state, action) => {
          state.gifts.isLoadingGift = true;
        }
      )
      .addMatcher(
        publicProfileApi.endpoints.getPublicGiftsPagedList.matchRejected, (state, action) => {
          state.gifts.isLoadingGift = false;
        }
      )
      .addMatcher(
        publicProfileApi.endpoints.getPublicGiftsPagedList.matchFulfilled, (state, action) => {
          state.gifts.isLoadingGift = false;
          state.gifts.giftList = action.payload;
        }
      )
      .addMatcher(
        countryApi.endpoints.getCountryByCode.matchFulfilled, (state, action) => {
          state.gifts.provinceOrStateList = action.payload.provinceOrStateList.map(provinceOrState => ({
            id: provinceOrState.id,
            value: provinceOrState.code,
            label: provinceOrState.description,
          }));
        }
      )
      .addMatcher(
        publicProfileApi.endpoints.getPublicSector.matchFulfilled, (state, action) => {
          state.gifts.sectorList = action.payload.map(item => ({
            id: item.id,
            value: item.sectorName,
            label: item.sectorName,
          }));
        }
      )
      .addMatcher(
        countryApi.endpoints.getCityListByProvinceOrStates.matchFulfilled, (state, action) => {
          state.gifts.cityList = action.payload.map(city => ({
            id: city.id,
            value: city.name,
            label: city.name,
            secondaryAction: city.provinceOrStateCode,
          }));
        }
      )
      .addMatcher(
        publicProfileApi.endpoints.getPublicDirectorsPagedList.matchFulfilled, (state, action) => {
          state.directors = action.payload;
        }
      )
      .addMatcher(
        publicProfileApi.endpoints.getPublicChartProvinceList.matchFulfilled, (state, action) => {
          state.charts.provinceList = action.payload;
        }
      )
      .addMatcher(
        publicProfileApi.endpoints.getPublicRangeAmountList.matchFulfilled, (state, action) => {
          state.charts.rangeAmount = action.payload;
        }
      )
      .addMatcher(
        publicProfileApi.endpoints.getPublicRangeSectorList.matchFulfilled, (state, action) => {
          state.charts.rangeSector = action.payload;
        }
      )
  }
});

export const {
  handleChangeFilter,
  handleChangeStemmingSearch,
  handleClearGifts,
  setCountry,
  setProfileId
} = publicFoundationProfileSlice.actions;

export default publicFoundationProfileSlice.reducer;
